var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",staticStyle:{"background":"#f5f5f5"}},[_c('div',{staticClass:"top"},[_c('top')],1),_c('div',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('router-view')],1)]),_c('div',{staticClass:"floor"},[_c('Floor')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }